(function(){
  function attach(formId){
    var form = document.forms[formId];
    if(!form) return;
    if(form.__vqgAttached) return;
    form.__vqgAttached = true;

    var root = document.querySelector('[data-variant-qty-grid][data-form-id="' + formId + '"]');
    if (!root) return;

    var productVariants = JSON.parse(root.previousElementSibling.textContent);

    function getTotalQty(){
      var total = 0;
      root.querySelectorAll('input[type="number"][data-variant-id]:not([disabled])').forEach(function(input){
        total += parseInt(input.value, 10) || 0;
      });
      return total;
    }

    function getSelectedOptions() {
      var options = [];
      
      var selectors = [
        'input[name^="' + form.id + '-option"]:checked',
        'select[name^="' + form.id + '-option"]',
        'input[name^="option"]:checked',
        'select[name^="option"]',
        '[data-option-select]',
        '[data-option-selector] .selected',
        '.selected-value',
        '.swatch-selected'
      ];
      
      var optionSelectors = [];
      for (var i = 0; i < selectors.length; i++) {
        optionSelectors = form.querySelectorAll(selectors[i]);
        if (optionSelectors.length > 0) break;
      }
      
      if (optionSelectors.length === 0) {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');
        
        if (variantId) {
          var urlVariant = productVariants.find(function(v) { return v.id.toString() === variantId; });
          if (urlVariant) {
            return urlVariant.options;
          }
        }
      }
      
      var positionedOptions = [];
      
      Array.from(optionSelectors).forEach(function(selector) {
        var position = 0;
        var value = '';
        
        if (selector.name) {
          var matches = selector.name.match(/option(\d+)/);
          if (matches && matches[1]) {
            position = parseInt(matches[1], 10);
            value = selector.value;
          }
        } else if (selector.dataset && selector.dataset.optionPosition) {
          position = parseInt(selector.dataset.optionPosition, 10);
          value = selector.dataset.optionValue || selector.textContent.trim();
        } else if (selector.closest && selector.closest('[data-option-index]')) {
          var parent = selector.closest('[data-option-index]');
          position = parseInt(parent.dataset.optionIndex, 10) + 1;
          value = selector.dataset.value || selector.textContent.trim();
        }
        
        if (position > 0) {
          positionedOptions[position-1] = value;
        }
      });
      
      for (var i = 0; i < 3; i++) {
        options[i] = positionedOptions[i] || '';
      }
      
      return options;
    }

    function findVariantForOptions(selectedOptions, exactMatch) {
      var variant = productVariants.find(function(variant) {
        if (exactMatch) {
          return variant.options.every(function(option, index) {
            return option === selectedOptions[index];
          });
        } else {
          return variant.options.every(function(option, index) {
            return !selectedOptions[index] || option === selectedOptions[index];
          });
        }
      });
      
      if (!variant) {
        var colorIndex = -1;
        var colorOption = null;
        
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] && 
              (productVariants.some(function(v) { 
                return v.options[i] === selectedOptions[i] && 
                       (v.options[i].toLowerCase().includes('color') || 
                        ['black', 'white', 'blue', 'red', 'green', 'yellow', 'purple', 
                         'pink', 'orange', 'grey', 'gray', 'brown', 'navy', 'ivory',
                         'blossom', 'chambray', 'spruce', 'moss', 'pepper', 'espresso',
                         'graphite', 'bay', 'jean'].some(function(color) {
                          return v.options[i].toLowerCase().includes(color);
                         }));
              }))) {
            colorIndex = i;
            colorOption = selectedOptions[i];
            break;
          }
        }
        
        if (colorIndex >= 0 && colorOption) {
          var colorMatchVariants = productVariants.filter(function(v) {
            return v.options[colorIndex] === colorOption;
          });
          
          if (colorMatchVariants.length > 0) {
            variant = colorMatchVariants.reduce(function(bestMatch, current) {
              var bestMatchCount = 0;
              var currentMatchCount = 0;
              
              for (var i = 0; i < selectedOptions.length; i++) {
                if (i !== colorIndex && selectedOptions[i]) {
                  if (bestMatch && bestMatch.options[i] === selectedOptions[i]) bestMatchCount++;
                  if (current.options[i] === selectedOptions[i]) currentMatchCount++;
                }
              }
              
              return currentMatchCount > bestMatchCount ? current : bestMatch;
            }, null);
          }
        }
      }
      
      return variant;
    }
    
    function buildItems(){
      var items = [];
      var otherSelectedOptions = getSelectedOptions();
      
      var gridContainer = root.querySelector('[data-grid-1d], [data-grid-2d]');
      var gridOptionIndex = parseInt(gridContainer.dataset.primaryIndex, 10) - 1;
      var is2DGrid = gridContainer.hasAttribute('data-grid-2d');
      var secondaryOptionIndex = is2DGrid ? parseInt(gridContainer.dataset.secondaryIndex, 10) - 1 : -1;
      
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');
      var urlVariant = null;
      
      if (urlVariantId) {
        urlVariant = productVariants.find(function(v) { return v.id.toString() === urlVariantId; });
        if (urlVariant) {
          for (var i = 0; i < otherSelectedOptions.length; i++) {
            if (i !== gridOptionIndex && i !== secondaryOptionIndex) {
              otherSelectedOptions[i] = urlVariant.options[i];
            }
          }
        }
      }
      
      root.querySelectorAll('input[data-variant-id]:not([disabled])').forEach(function(input){
        var qty = parseInt(input.value, 10) || 0;
        if(qty > 0){
          var currentOptions = [...otherSelectedOptions];
          
          var variantTitle = input.dataset.variantTitle;
          var variantOptions = variantTitle.split(' / ');
          
          if (is2DGrid) {
            currentOptions[gridOptionIndex] = variantOptions[0];
            if (secondaryOptionIndex >= 0 && variantOptions.length > 1) {
              currentOptions[secondaryOptionIndex] = variantOptions[1];
            }
          } else {
            currentOptions[gridOptionIndex] = variantOptions[0];
          }
          
          var variant = findVariantForOptions(currentOptions, true);
          
          if (variant) {
            items.push({ id: variant.id, quantity: qty });
          } else {
            variant = findVariantForOptions(currentOptions, false);
            if (variant) {
              items.push({ id: variant.id, quantity: qty });
            } else {
              items.push({ id: input.getAttribute('data-variant-id'), quantity: qty });
            }
          }
        }
      });
      return items;
    }

    function updateButtonState() {
      var buyButtonsContainer = form.querySelector('.buy-buttons');
      if (!buyButtonsContainer) return;

      var totalQty = getTotalQty();
      var isDisabled = totalQty === 0;

      var submitButton = buyButtonsContainer.querySelector('button[type="submit"]');
      if (submitButton) { submitButton.disabled = isDisabled; }

      var dynamicCheckoutButton = buyButtonsContainer.querySelector('.shopify-payment-button');
      if (dynamicCheckoutButton) { dynamicCheckoutButton.classList.toggle('is-disabled', isDisabled); }
    }

    root.addEventListener('input', updateButtonState);
    
    form.addEventListener('variant:change', function(e) { 
      setTimeout(updateButtonState, 10); 
    });
    
    form.addEventListener('product:rerender', function() { 
      setTimeout(updateButtonState, 10); 
    });
    
    var mo = new MutationObserver(function() { 
      setTimeout(updateButtonState, 10); 
    });
    
    mo.observe(form, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
    
    updateButtonState();

    document.addEventListener('click', function(e){
      var buyButtonsContainer = form.querySelector('.buy-buttons');
      if (!buyButtonsContainer) return;
      var dynContainer = buyButtonsContainer.querySelector('.shopify-payment-button');
      if (!dynContainer) return;
      if (!dynContainer.contains(e.target)) return;

      var items = buildItems();
      if (items.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      addItemsAndProceed(items, true);
    }, true);

    form.addEventListener('submit', function(event){
      var root = document.querySelector('[data-variant-qty-grid][data-form-id="'+formId+'"]');
      if(!root) return;

      var items = buildItems();
      if(items.length){
        event.preventDefault();
        event.stopImmediatePropagation();
        addItemsAndProceed(items, false);
      }
    }, true);

    function addItemsAndProceed(items, goToCheckout){
      var submitBtns = form.querySelectorAll('button[type="submit"]');
      submitBtns.forEach(function(btn){ btn.setAttribute('aria-busy', 'true'); });
      
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      var formData = new FormData();
      items.forEach(function(item) { formData.append('items[][id]', item.id); formData.append('items[][quantity]', item.quantity); });
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', window.location.pathname);

      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function(response) { return response.json().then(function(json){ return { ok: response.ok, json: json }; }); })
      .then(function(response){
        submitBtns.forEach(function(btn){ btn.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        if (response.ok) {
          if (goToCheckout) {
            window.location.href = window.Shopify.routes.root + 'checkout';
            return;
          }
          fetch(window.Shopify.routes.root + 'cart.js')
          .then(function(res){ return res.json(); })
          .then(function(cartContent){
            cartContent["sections"] = response.json["sections"];
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
          });
        } else {
          form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: response.json.description || response.json.message } }));
        }
      })
      .catch(function(error){
        var submitBtns = form.querySelectorAll('button[type="submit"]');
        submitBtns.forEach(function(btn){ btn.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } }));
      });
    }
  }

  function flushQueue(){
    if(!Array.isArray(window.__variantQtyGrid)) return;
    window.__variantQtyGrid.forEach(function(cfg){ attach(cfg.formId); });
    window.__variantQtyGrid.length = 0;
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', flushQueue);
  } else {
    flushQueue();
  }
})(); 